module.exports = __webpack_public_path__ + "static/media/Poppins-Medium.0b9a0c53.woff2";